import request from '@/router/axios';
const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/wage' : '/wage'

/**
 * 查询所有文件
 * @param {Object} params - { refreshFlag: 'true'|'false' }
 */
export function queryAllFile(params) {
  return request({
    url: urlPrefix+ '/seagate/fileDownloads/queryAllFile',
    method: 'get',
    params: params
  })
}

/**
 * 下载文件
 * @param {Object} data - { downloadFileId, downloadFilePath, downloadFileName, isFolder, downloadFileChildren }
 */
export function downloadFiles(data) {
  return request({
    url: urlPrefix+ '/seagate/fileDownloads/downloadFiles',
    method: 'post',
    data: data,
    responseType: 'arraybuffer'
  })
}

/**
 * 查询历史记录（分页）
 * @param {Object} params - { pageIndex, pageSize, fileName, getDate }
 */
export function queryHistoryRecord(params) {
  return request({
    url: urlPrefix+ '/seagate/fileDownloads/queryHistoryRecord',
    method: 'post',
    data: params
  })
}

/**
 * 下载历史记录
 * @param {Object} data - { fileIds }
 */
export function downloadHistoryRecord(data) {
  return request({
    url: urlPrefix+ '/seagate/fileDownloads/downloadHistoryRecord',
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  })
}


/**
 * 上传文件
 * @param {FormData} formData - 包含 file 和 filename
 */
export function uploadSeagateFile(formData) {
  return request({
    url: urlPrefix+ '/seagate/fileDownloads/uploadSeagateFile',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 删除历史记录
 * @param {Object} data - { fileIds }
 */
export function deleteHistoryRecord(data) {
  return request({
    url: urlPrefix+ '/seagate/fileDownloads/deleteHistoryRecord',
    method: 'get',
    params: data
  })
}
